import { useQuery } from '@tanstack/react-query';

import { Mc3Client } from './client';
import { campaignQueryKeys } from './queryKeys';

export function useAdvertisers() {
  const { data, ...query } = useQuery({
    queryKey: campaignQueryKeys.advertisers(),
    queryFn: async () =>
      Mc3Client.get('api/campaigns/advertisers').json<string[]>(),
  });

  return {
    advertisers: data ?? [],
    ...query,
  };
}
